import React from 'react'
import classnames from 'classnames'
import style from './MediaCarouselItem.module.scss'
import { MediaCarouselItemPropsInterface } from './types'
import Icon, { IconType } from '@bt-react/components/Icon'

class MediaCarouselItem extends React.Component<MediaCarouselItemPropsInterface> {

  shouldComponentUpdate (nextProps: Readonly<MediaCarouselItemPropsInterface>, nextState: Readonly<{}>, nextContext: any): boolean {

    return this.props.selected !== nextProps.selected || this.props.content !== nextProps.content

  }

  render () {

    const listItemClasses = classnames(
      style[`List-Item`], {
        [style[`List-Item--selected`]]: this.props.selected
      }
    )

    return <li
      className={listItemClasses}
      data-bdd={this.props.dataBdd || `MediaCarouselItem`}
    >
      <div className={style[`List-Item-Select-Arrow`]}>
        {
          this.props.selected &&
            <Icon
              colour={IconType.colour.brightTALK}
              className={style[`List-Item-Icon`]}
              name={IconType.iconName.sortDown}
            />
        }
      </div>
      <div className={style[`List-Item-Content`]}>
        {React.cloneElement(this.props.content, { selected: this.props.selected })}
      </div>
    </li>

  }

}

export default MediaCarouselItem
